export default __webpack_public_path__ + "static/media/dayIco.398e4298.svg";